import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Permisos from './permisos';
import { PERMISOS_CONFIG } from './permisos.config';

const buildPermisosIniciales = () => {
  const data = {};
  PERMISOS_CONFIG.forEach(m => {
    data[m.key] = false;
  });
  return data;
};

const UsuarioForm = () => {
  const history = useHistory();

  const [form, setForm] = useState({
    nombres: '',
    apellidos: '',
    correo: '',
    telefono: '',
    tipo: 'Limitado'
  });

  const [permisos, setPermisos] = useState(buildPermisosIniciales());

  const onChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const guardarUsuario = () => {
    const payload = {
      ...form,
      permisos
    };

    console.log('GUARDAR USUARIO:', payload);
  };

  return (
    <div className="container-fluid">

      <button
        className="btn btn-success mb-4"
        onClick={() => history.goBack()}
      >
        ⬅ Atrás
      </button>

      <div className="card">
        <div className="card-body">

          <div className="row">
            <div className="col-md-6">
              <label>Nombres</label>
              <input
                className="form-control"
                name="nombres"
                value={form.nombres}
                onChange={onChange}
              />
            </div>

            <div className="col-md-6">
              <label>Apellidos</label>
              <input
                className="form-control"
                name="apellidos"
                value={form.apellidos}
                onChange={onChange}
              />
            </div>

            <div className="col-md-6 mt-3">
              <label>Correo</label>
              <input
                className="form-control"
                name="correo"
                value={form.correo}
                onChange={onChange}
              />
            </div>

            <div className="col-md-6 mt-3">
              <label>Teléfono</label>
              <input
                className="form-control"
                name="telefono"
                value={form.telefono}
                onChange={onChange}
              />
            </div>

            <div className="col-md-6 mt-3">
              <label>Tipo Usuario</label>
              <select
                className="form-control"
                name="tipo"
                value={form.tipo}
                onChange={onChange}
              >
                <option>Administrador</option>
                <option>Limitado</option>
              </select>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <button className="btn btn-success mr-2">
              Reenviar Contraseña
            </button>
            <button
              className="btn btn-success"
              onClick={guardarUsuario}
            >
              Guardar Usuario
            </button>
          </div>

          <hr className="my-4" />

          <div className="d-flex align-items-center mb-3">
            <h5 className="mb-0">Permisos</h5>
            <span className="ml-2 text-muted">Seleccionar accesos</span>
          </div>

          <Permisos permisos={permisos} onChange={setPermisos} />

          <div className="d-flex justify-content-end mt-4">
            <button className="btn btn-success mr-2">
              Reenviar Contraseña
            </button>
            <button
              className="btn btn-success"
              onClick={guardarUsuario}
            >
              Guardar Usuario
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default UsuarioForm;
